//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import translations from '~/i18n/services';

import BcIsoCertificate from '@/components/svg/bc-iso-certificate.vue';
import DutchLaravelFoundation from '@/components/svg/dutch-laravel-foundation.vue';
import LaravelCertificate from '@/components/svg/laravel-certificate.vue';

export default {
    components: {
        BcIsoCertificate,
        CaseSingleOverview: () => import('~/components/case/single-overview.vue'),
        DutchLaravelFoundation,
        LaravelCertificate,
        ServicesRelated: () => import('~/components/services/related.vue'),
        UiTagline: () => import('~/components/ui/tagline.vue'),
    },
    scrollToTop: true,
    async asyncData({ params, i18n, error }) {
        const { slug } = await params;
        let trans;

        try {
            trans = translations[slug][i18n.locale];
        } catch {
            return error({ statusCode: 404 });
        }

        if (!trans.content) return error({ statusCode: 404 });

        return { trans };
    },
    head() {
        return {
            meta: [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.trans.title,
                },
            ],
            title: this.trans.title,
            description: this.trans.description,
        };
    },
    computed: {
        ...mapState(['contacts']),

        currentContact() {
            return this.contacts[this.trans.contact.employee];
        },
    },
};
